import styled from 'styled-components';
import { normalize } from 'utils/styles';
import { color, media } from 'styles/settings';
import { animated } from 'react-spring';

export const MiniMapHolder = styled(animated.div)`
  background-color: ${color.neutral.white};
  bottom: ${normalize('20px')};
  right: ${normalize('20px')};
  width: ${({ width }) => width}px;
  position: fixed;
  z-index: 2;
  ${media.mediaQueries.mobile`
    /* display:none; */
  `}
`;
